import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-54cf51be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-wrap ptb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "service-card style4" }
const _hoisted_5 = { class: "service-info" }
const _hoisted_6 = { class: "service-title" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["src"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-payment-method" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-right-arrow" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://wa.me/+22946621196/?text=Bonjour, j'ai besoin d'une pièce",
    target: "_blank",
    class: "btn btn-sm style1"
  }, "Discuter avec un agent de La Poste du Bénin SA")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-4 col-lg-6 col-md-6",
            key: index
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (article.icone)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                        _createElementVNode("img", {
                          src: _ctx.getUrlApiForFiles(article.icone),
                          alt: "Image",
                          class: "blogimg"
                        }, null, 8, _hoisted_8)
                      ]))
                    : _createCommentVNode("", true),
                  (!article.icone)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _hoisted_11))
                    : _createCommentVNode("", true),
                  _createElementVNode("h3", null, [
                    _createElementVNode("a", {
                      href: article.source,
                      target: "_blank"
                    }, _toDisplayString(article.titre), 9, _hoisted_12)
                  ])
                ]),
                _createElementVNode("a", {
                  href: article.source,
                  target: "_blank",
                  class: "link style1"
                }, [
                  _createTextVNode("Obtenir la pièce "),
                  _hoisted_14
                ], 8, _hoisted_13)
              ])
            ])
          ]))
        }), 128))
      ]),
      _hoisted_15
    ])
  ]))
}